import { apiRoutes } from 'config/apiRoutes'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import type { FabricsRes } from 'features/fabrics/types/fabrics.types'
import { useContext } from 'react'
import { AuthContext } from 'store'
import { queryKeys } from 'config/queryKeys'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchFabrics = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const query = getCurrentQuery()

	const { data: fabrics, isPending: isFabricsLoading } = useQuery<FabricsRes>({
		queryKey: queryKeys.fabrics.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.fabrics(query ?? '')),
		enabled: !!auth.accessToken
	})

	return {
		fabrics,
		isFabricsLoading
	}
}
